import React, { useState, useEffect } from "react";
import {Grid, Row, Col} from "react-flexbox-grid";
import CloseIcon from "../CloseIcon";
import {Switch, Modal, Select} from "antd";
import { getBrowserLanguage } from "../util";

import ModalRow from "../ModalRow";

const { Option } = Select;

function OptionsRow(props) {
	return (
		<Row style={props.style}>
			<Col lg={10} md={10} sm={10} xs={9} style={{textAlign: "start"}}>
				<span className="message">{props.optionText}</span>
			</Col>
			<Col lg={2} md={2} sm={2} xs={3}>
				<Switch
					checked={props.useOption}
					onChange={checked => props.setUseOption(checked)}
					disabled={props.disabled}
				/>
			</Col>
		</Row>
	);
}

function LanguageRow(props) {
	const [selectedLanguage, setSelectedLanguage] = useState("default");

	useEffect(() => {
		// Load saved language from localStorage on component mount
		const savedLanguage = localStorage.getItem("userLanguage");
		if (savedLanguage) {
			setSelectedLanguage(savedLanguage);
		}
	}, []);

	const handleLanguageChange = (value) => {
		setSelectedLanguage(value);
		if (value === "default") {
			// Remove from localStorage when default is selected
			localStorage.removeItem("userLanguage");
		} else {
			// Save ISO string to localStorage
			localStorage.setItem("userLanguage", value);
		}
	};

	return (
		<Row style={props.style}>
			<Col lg={6} md={6} sm={6} xs={5} style={{textAlign: "start"}}>
				<span className="message">Language</span>
			</Col>
			<Col lg={6} md={6} sm={6} xs={7}>
				<Select
					value={selectedLanguage}
					onChange={handleLanguageChange}
					style={{
						width: "100%",
						fontFamily: 'AkkuratMono-Regular',
						textTransform: 'uppercase',
						borderColor: '#fff',
					}}
					size="small"
				>
					<Option value="default">Default ({navigator.language || navigator.userLanguage || 'en-US'})</Option>
					<Option value="en-US">English (US)</Option>
					<Option value="en-GB">English (UK)</Option>
					<Option value="es-ES">Español</Option>
					<Option value="fr-FR">Français</Option>
					<Option value="de-DE">Deutsch</Option>
					<Option value="it-IT">Italiano</Option>
					<Option value="pt-BR">Português (Brasil)</Option>
					<Option value="ja-JP">日本語</Option>
					<Option value="ko-KR">한국어</Option>
					<Option value="zh-CN">中文 (简体)</Option>
					<Option value="zh-TW">中文 (繁體)</Option>
					<Option value="ru-RU">Русский</Option>
					<Option value="ar-SA">العربية</Option>
					<Option value="hi-IN">हिन्दी</Option>
				</Select>
			</Col>
		</Row>
	);
}

function OptionsModal(props) {
	const options = props.options;
	const numSelected = [
		options.useStandardSet,
		options.useExpandedSet,
		options.useBollywoodSet,
		options.usePreBlockbusterSet
	].filter(x => x === true).length;
	return (
		<Modal
			closeIcon={<CloseIcon />}
			visible={props.visible}
			onCancel={props.onCancel}
			footer={null}
			centered
			width={550}
		>
			<ModalRow title="Options" />
			<Grid style={{padding: "16px 60px 32px"}}>
				<LanguageRow />
				<OptionsRow
					style={{marginTop: 8}}
					optionText="Cannot use films from a series"
					useOption={options.cannotUseSeries}
					setUseOption={options.setCannotUseSeries}
				/>
				<div style={{marginBottom: 24}} />
				<p className="modal-subtitle">- Choose For Me -</p>
				<OptionsRow
					optionText="Use default actors"
					useOption={options.useStandardSet}
					setUseOption={options.setUseStandardSet}
					disabled={options.useStandardSet && numSelected === 1}
				/>
				<OptionsRow
					style={{marginTop: 8}}
					optionText="Use expanded actors"
					useOption={options.useExpandedSet}
					setUseOption={options.setUseExpandedSet}
					disabled={options.useExpandedSet && numSelected === 1}
				/>
				<OptionsRow
					style={{marginTop: 8}}
					optionText="Use Bollywood actors"
					useOption={options.useBollywoodSet}
					setUseOption={options.setUseBollywoodSet}
					disabled={options.useBollywoodSet && numSelected === 1}
				/>
				<OptionsRow
					style={{marginTop: 8}}
					optionText="Use pre-blockbuster era actors"
					useOption={options.usePreBlockbusterSet}
					setUseOption={options.setUsePreBlockbusterSet}
					disabled={options.usePreBlockbusterSet && numSelected === 1}
				/>
			</Grid>
		</Modal>
	);
}

export default OptionsModal;
